export function logEvent(event) {
    if (window) {
      window.digitalData = window.digitalData || {}
      window.digitalData.events = window.digitalData.events || []
      window.digitalData.events.push(event)
    }
  }

export function logModalAction(modalAction,subCategory1,eventName) {
    const event = {
      category: {
        primaryCategory: getCurrentPageCategory(),
        subCategory1: subCategory1,
      },
      eventInfo: {
        effect: 'OK',
        eventAction: modalAction,
        eventName: eventName,
        eventPoints: '',
        eventTargetUrl: '',
        timeStamp: new Date().toISOString(),
        type: "Modal",
      }
    }
    logEvent(event)
  }


export function getCurrentPageCategory() {
    if (window) {
      return window?.digitalData?.page?.category?.primaryCategory ?? ''
    }
    return ''
  }
